export class Email {
  constructor(private _email: string) {
    // Strip by default
    this._email = this._email.trim().toLocaleLowerCase();
  }

  toString() {
    return String(this._email);
  }
}
